import countrynames_en from "@/assets/data/countrynames";
import countrynames_fr from "@/assets/data/countrynames_fr";
import countrynames_es from "@/assets/data/countrynames_es";
import countrynames_pt from "@/assets/data/countrynames_pt";
import domains_en from "@/assets/data/domains";
import domains_fr from "@/assets/data/domains_fr";
import domains_es from "@/assets/data/domains_es";
import domains_pt from "@/assets/data/domains_pt";

export default function getTranslations(i18nInstance) {
    const locale = i18nInstance.locale;
    
    const mapCountryNames = {
        en: countrynames_en,
        fr: countrynames_fr,
        es: countrynames_es,
        pt: countrynames_pt
    }

    const mapDomains = {
        en: domains_en,
        fr: domains_fr,
        es: domains_es,
        pt: domains_pt
    }

    // a3_web_text_prev.csv (boys & girls)
    const mapPrevalenceColumn = {
        en: "en_text",
        fr: "fr_text",
        es: "es_text",
        pt: "pt_text"
    }

    const mapPolicyTexts = {
        en: "/policy_texts.json",
        fr: "/policy_texts_fr.json",
        es: "/policy_texts_es.json",
        pt: "/policy_texts_pt.json"
    }

    const mapCitationsTexts =  {
        en: "/policy_citations.json",
        fr: "/policy_citations_fr.json"
    }

    const countryNames = mapCountryNames[locale];

    const domains = mapDomains[locale];

    const prevalenceColumn = mapPrevalenceColumn[locale];

    const policyTexts = mapPolicyTexts[locale];

    const citationsTexts = mapCitationsTexts[locale] || mapCitationsTexts["en"];

    return { countryNames, domains, prevalenceColumn, policyTexts, citationsTexts }
}